import { cfgSupportChatApiUrl } from '@infinitro/config';
import { getCurrentToken } from '@infinitro/global';
import { supportChatDebug, supportChatWarn } from '../debug';
export function normalizeSupportChatBaseUrl(raw) {
    return raw.replace(/\/+$/, '');
}
export function supportChatHttpUrl(path) {
    const base = normalizeSupportChatBaseUrl(cfgSupportChatUrlOrThrow());
    const p = path.startsWith('/') ? path : `/${path}`;
    return `${base}${p}`;
}
export function supportChatWsUrl(token) {
    const base = cfgSupportChatApiUrl() ?? '';
    if (!base)
        throw new Error('support chat API URL is not configured');
    const u = new URL(base.includes('://') ? base : `https://${base}`);
    const wsProto = u.protocol === 'https:' ? 'wss:' : 'ws:';
    const pathPrefix = u.pathname.replace(/\/+$/, '');
    return `${wsProto}//${u.host}${pathPrefix}/ws?token=${encodeURIComponent(token)}`;
}
function cfgSupportChatUrlOrThrow() {
    const u = cfgSupportChatApiUrl();
    if (!u)
        throw new Error('support chat API URL is not configured');
    return u;
}
export async function supportChatFetch(path, init = {}) {
    const url = supportChatHttpUrl(path);
    const token = getCurrentToken();
    const headers = new Headers(init.headers);
    if (token)
        headers.set('x-access-token', token);
    if (!headers.has('Accept'))
        headers.set('Accept', 'application/json');
    let body = init.body;
    if (init.json !== undefined) {
        headers.set('Content-Type', 'application/json');
        body = JSON.stringify(init.json);
    }
    const method = init.method ?? 'GET';
    supportChatDebug('HTTP request start', {
        method,
        url,
        hasToken: Boolean(token),
        body: init.json ?? body ?? null
    });
    const startedAt = Date.now();
    const res = await fetch(url, { ...init, headers, body });
    const elapsedMs = Date.now() - startedAt;
    const log = res.ok ? supportChatDebug : supportChatWarn;
    log('HTTP request complete', {
        method,
        url,
        status: res.status,
        ok: res.ok,
        elapsedMs
    });
    return res;
}
